import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  // 持久化插件引入
  plugins: [createPersistedState()],
  state: {
    token: null,
    userinfo: null,
    userid: null,
    wechatLoginState: null // 微信二维码登录的时候传递过来的二维码state
  },
  mutations: {
    // 设置微信登录state
    setWechatLoginState(state, data) {
      state.wechatLoginState = data;
      console.log("设置登录", state.wechatLoginState);
    },
    SET_TOKEN(state, data) {
      state.token = data;
    },
    SET_USERINFO(state, data) {
      state.userinfo = data;
    },
    SET_USERID(state, data) {
      state.userid = data;
    }
  },
  actions: {},
  modules: {}
});
